import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import IdleTimeWrapper from "./components/hoc/IdleTimeWrapper";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";

ReactDOM.render(
  <IdleTimeWrapper>
    <App />
  </IdleTimeWrapper>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
